import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { formatNumber } from '@progress/kendo-intl';

export class TotalChargesCell extends React.Component<GridCustomCellProps> {
    render() {
        return <td {...this.props.tdProps} style={{ textAlign: "right" }}>{formatNumber(this.props.dataItem.TotalCharges, "c")}</td>;
    }

    public shouldComponentUpdate(nextProps: GridCustomCellProps) {
        return this.props.dataItem[this.props.field] !== nextProps.dataItem[this.props.field];
    }
}